// Erweiterte Stimmungen für das Logbuch
// 24 Optionen in 5 Kategorien

import type { LogbookMoodOption, LogbookMoodCategory } from '../types';

export const MOOD_CATEGORIES: { id: LogbookMoodCategory; label: string; emoji: string }[] = [
  { id: 'positive', label: 'Positiv', emoji: '😊' },
  { id: 'neutral', label: 'Neutral', emoji: '😌' },
  { id: 'mixed', label: 'Gemischt', emoji: '🤔' },
  { id: 'special', label: 'Besonders', emoji: '✨' },
  { id: 'energy', label: 'Energie', emoji: '⚡' },
];

export const EXTENDED_MOOD_OPTIONS: LogbookMoodOption[] = [
  // Positiv
  { value: 'great', label: 'Wunderbar', emoji: '😊', category: 'positive' },
  { value: 'happy', label: 'Glücklich', emoji: '😄', category: 'positive' },
  { value: 'excited', label: 'Begeistert', emoji: '🤩', category: 'positive' },
  { value: 'inspired', label: 'Inspiriert', emoji: '💡', category: 'positive' },
  { value: 'grateful', label: 'Dankbar', emoji: '🙏', category: 'positive' },
  { value: 'romantic', label: 'Romantisch', emoji: '💕', category: 'positive' },

  // Neutral
  { value: 'good', label: 'Gut', emoji: '🙂', category: 'neutral' },
  { value: 'neutral', label: 'Okay', emoji: '😐', category: 'neutral' },
  { value: 'calm', label: 'Ruhig', emoji: '😌', category: 'neutral' },
  { value: 'focused', label: 'Fokussiert', emoji: '🎯', category: 'neutral' },
  { value: 'curious', label: 'Neugierig', emoji: '🧐', category: 'neutral' },

  // Gemischt
  { value: 'mixed', label: 'Gemischt', emoji: '😕', category: 'mixed' },
  { value: 'nostalgic', label: 'Nostalgisch', emoji: '🥹', category: 'mixed' },
  { value: 'thoughtful', label: 'Nachdenklich', emoji: '🤔', category: 'mixed' },
  { value: 'bittersweet', label: 'Bittersüß', emoji: '🥲', category: 'mixed' },

  // Besonders
  { value: 'special', label: 'Besonders', emoji: '✨', category: 'special' },
  { value: 'celebration', label: 'Feier', emoji: '🎉', category: 'special' },
  { value: 'milestone', label: 'Meilenstein', emoji: '🏆', category: 'special' },
  { value: 'discovery', label: 'Entdeckung', emoji: '🔍', category: 'special' },
  { value: 'firsttime', label: 'Erstes Mal', emoji: '🌟', category: 'special' },

  // Energie
  { value: 'energized', label: 'Energiegeladen', emoji: '⚡', category: 'energy' },
  { value: 'relaxed', label: 'Entspannt', emoji: '😎', category: 'energy' },
  { value: 'tired', label: 'Müde', emoji: '😴', category: 'energy' },
  { value: 'cozy', label: 'Gemütlich', emoji: '☕', category: 'energy' },
];

// Hilfsfunktion: Mood nach Value finden
export function getMoodByValue(value: string): LogbookMoodOption | undefined {
  return EXTENDED_MOOD_OPTIONS.find((m) => m.value === value);
}

// Hilfsfunktion: Moods nach Kategorie gruppieren
export function getMoodsByCategory(category: LogbookMoodCategory): LogbookMoodOption[] {
  return EXTENDED_MOOD_OPTIONS.filter((m) => m.category === category);
}

// Legacy-Mapping für alte Einträge (5 alte Moods auf neue mappen)
export const LEGACY_MOOD_MAPPING: Record<string, string> = {
  great: 'great',
  good: 'good',
  neutral: 'neutral',
  mixed: 'mixed',
  special: 'special',
};

// Hilfsfunktion: Legacy mood zu neuem Format konvertieren
export function migrateLegacyMood(legacyMood?: string): string[] {
  if (!legacyMood) return [];
  return [LEGACY_MOOD_MAPPING[legacyMood] || legacyMood];
}
